  <template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="调整内容" prop="adjustContent">
            <el-select v-model="searchForm.adjustContent" clearable @change="onSearch">
              <el-option label="销售状态" value="销售状态"></el-option>
              <el-option label="发货周期" value="发货周期"></el-option>
              <el-option label="SKU推广名称" value="SKU推广名称"></el-option>
              <el-option label="设计图" value="设计图"></el-option>
              <el-option label="价格相关" value="价格相关"></el-option>
              <el-option label="通栏图" value="通栏图"></el-option>
              <el-option label="是否松木" value="是否松木"></el-option>
              <el-option label="设计图作废" value="设计图作废"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否紧急" prop="emergency">
            <el-select v-model="searchForm.emergency" clearable @change="onSearch">
              <el-option label="紧急" value="1"></el-option>
              <el-option label="不紧急" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通知时间">
            <form-date-range :form="searchForm" startKey="dts" :usingTime="false" endKey="dte" valueFormat="yyyy-MM-dd"> </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">查询</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="adjustContent" label="调整内容" min-width="120"></el-table-column>
        <el-table-column prop="emergency" label="是否紧急" min-width="100"></el-table-column>
        <el-table-column prop="noticeTime" label="通知时间" min-width="160"></el-table-column>
        <el-table-column prop="storeQty" label="通知店铺数" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="viewStoreList(scope.row)">
              {{ scope.row.storeQty }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="skuQty" label="涉及商品/型号数" min-width="140">
          <template slot-scope="scope">
            <el-button type="text" @click="viewProductList(scope.row)">
              {{ scope.row.skuQty }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="replyRate" label="回复率" min-width="100">
          <template #header>
            <span class="header-with-tips">
              回复率
              <el-tooltip
                class="item"
                effect="dark"
                content="已确认商品/型号数（各店铺汇总） /  [已确认商品/型号数（各店铺汇总）+ 未确认商品/型号数（各店铺汇总）]"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.replyRate }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="通知人" min-width="250" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creationDate" label="操作时间" min-width="160"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleReNotify(row)">
              再次发送通知
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 通知店铺详情弹窗 -->
    <store-detail-dialog
      :visible.sync="storeDetailVisible"
      :rowData="rowData"
      :storeList="storeList"
      v-if="storeDetailVisible"
    />
    
    <!-- 涉及商品型号详情弹窗 -->
    <product-detail-dialog
      :visible.sync="productDetailVisible"
      :rowData="rowData"
      v-if="productDetailVisible"
    />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import axios from '@/utils/axiosInstance';
import storeDetailDialog from './components/store-detail-dialog.vue';
import productDetailDialog from './components/product-detail-dialog.vue';
export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: { 
    storeDetailDialog,
    productDetailDialog
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      imgFormVisible: false,
      storeDetailVisible: false,
      productDetailVisible: false,
      searchFormData: [],
      rules: {},
      storeList: [],
      loading: false,
      searchForm: {
        adjustContent: '',
        emergency: '',
        dte: '',
        dts: '',
      },
      rowData: {},
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
    this.getStoreList();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.searchFormData = data;
      this.$q.goods
        .goodsInfoPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.searchForm = {
        adjustContent: '',
        emergency: '',
        notifyTimeType: '',
        endTimeType: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    // 查看店铺列表
    viewStoreList(row) {
      this.rowData = {...row}
      this.storeDetailVisible = true
    },

    // 查看商品列表
    viewProductList(row) {
      this.rowData = {...row}
      this.productDetailVisible = true;
    },

    getStoreList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "smallPiecesStoreConfigList",
        hasCount: "N",
      };
      axios.post(`/ec-pc-api/custom/reports/data/smallPiecesStoreConfigList`, data).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list.filter(v=>v.storeName != '全平台');
        }
      });
    },

    // 再次发送通知 - 二次确认
    async handleReNotify(row) {
      let status = await this.$confirm("确认要再次发送通知吗？",'提示', {type: 'warning'});
      if(status !== 'confirm') return ;
      const data = new FormData();
      data.append('noticeNo', row.noticeNo);
      let res = await this.$q.goods.reNotice({data: data})
      if(res.success) {
        this.$message.success('通知成功')
      }else{
        this.$message.fail('通知失败')
      }
      this.init();
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
</style>
